import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ProfileComponent } from './profile/profile.component';
import { SignatureComponent } from './signature/signature.component';
import { UploadSignatureComponent } from './signature/upload-signature/upload-signature.component';
import { CongesComponent } from './conges/conges.component';
import { ChangePasswordComponent } from './change-password/change-password.component';


@NgModule({
  imports: [
    CommonModule,
    AccountRoutingModule,
    SharedModule,
  ],

  declarations: [
    ProfileComponent,
    SignatureComponent,
    UploadSignatureComponent,
    CongesComponent,
    ChangePasswordComponent
  ],

  entryComponents: [
    UploadSignatureComponent
  ],

  providers: [
  ],

})
export class AccountModule { }